import { useUnit } from 'effector-react';
import { t } from 'i18next';
import { Button } from '@mui/material';
import { history } from '@features/common';
import {
  $notReadImports,
  exportInterrupt,
  downloadFile,
  importReadNotification,
  refreshTableAfterSuccessImportOnSamePage,
} from '../../../model';
import { Process, processStatuses } from '../../../types';
import { GetImportIcon } from './getImportIcon';
import * as Styled from './styled';

const NotReadImport = ({
  data,
  setImportPopperOpened,
}: {
  data: Process;
  setImportPopperOpened: (status: boolean) => void;
}) => {
  const goToUrl = () => {
    if (data.status !== processStatuses.finished) return;

    setImportPopperOpened(false);

    if (history.location.pathname === `/${data.bms_section}`) {
      refreshTableAfterSuccessImportOnSamePage();

      return;
    }

    history.push(`/${data.bms_section}`);
  };

  const handleClick = () => {
    if (data.status === processStatuses.processing) return;
    importReadNotification([data.id]);

    goToUrl();
  };

  const onExportInterrupt = (id: string | number) => () => {
    exportInterrupt(id);
  };

  const onDownloadFile = (id: string | number) => () => {
    downloadFile({ process_id: id, fileName: data.filename });
  };

  return (
    <Styled.NotReadImport>
      <Styled.NotReadImportMain
        onClick={handleClick}
        cursorPointer={data.status === processStatuses.processing ? 0 : 1}
      >
        <GetImportIcon status={data.status} />

        <Styled.NotReadImportText>
          <Styled.BrokenTypography variant="body1" title={data.title}>
            {data.title}
          </Styled.BrokenTypography>

          <Styled.BrokenTypography
            variant="body2"
            color="text.secondary"
            title={data.filename}
          >
            {data.filename}
          </Styled.BrokenTypography>
        </Styled.NotReadImportText>
      </Styled.NotReadImportMain>

      {data.status === processStatuses.processing && (
        <Button variant="text" size="small" onClick={onExportInterrupt(data.id)}>
          {t('cancel')}
        </Button>
      )}

      {data.status === processStatuses.finished && (
        <Button variant="text" size="small" onClick={onDownloadFile(data.id)}>
          {t('Download')}
        </Button>
      )}
    </Styled.NotReadImport>
  );
};

export const ImportsData = ({
  setImportPopperOpened,
}: {
  setImportPopperOpened: (status: boolean) => void;
}) => {
  const [notReadImports] = useUnit([$notReadImports]);

  return (
    <Styled.NotReadImportContainer>
      {notReadImports.map((notReadImport) => (
        <NotReadImport
          key={notReadImport.id}
          data={notReadImport}
          setImportPopperOpened={setImportPopperOpened}
        />
      ))}
    </Styled.NotReadImportContainer>
  );
};
